import React, { createContext, useContext, useState } from 'react';

const LangContext = createContext({});

const translations = {
  pt: {
    // Auth
    login: 'Entrar',
    email: 'E-mail',
    password: 'Senha',
    logout: 'Sair',
    
    // Common
    loading: 'Carregando...',
    save: 'Salvar',
    cancel: 'Cancelar',
    delete: 'Deletar',
    edit: 'Editar',
    create: 'Criar',
    search: 'Buscar',
    
    // Modules
    modules: 'Módulos',
    myModules: 'Meus Materiais',
    moduleTitle: 'Título do Módulo',
    moduleDescription: 'Descrição',
    createModule: 'Criar Módulo',
    editModule: 'Editar Módulo',
    
    // Videos
    videos: 'Vídeos',
    uploadVideo: 'Upload de Vídeo',
    videoTitle: 'Título do Vídeo',
    
    // Students
    students: 'Alunos',
    manageAccess: 'Gerenciar Acessos',
    grantAccess: 'Conceder Acesso',
    revokeAccess: 'Revogar Acesso',
    
    // Admin
    adminPanel: 'Painel Admin',
    dashboard: 'Dashboard'
  },
  en: {
    // Auth
    login: 'Login',
    email: 'Email',
    password: 'Password',
    logout: 'Logout',
    
    // Common
    loading: 'Loading...',
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    create: 'Create',
    search: 'Search',
    
    // Modules
    modules: 'Modules',
    myModules: 'My Modules',
    moduleTitle: 'Module Title',
    moduleDescription: 'Description',
    createModule: 'Create Module',
    editModule: 'Edit Module',
    
    // Videos
    videos: 'Videos',
    uploadVideo: 'Upload Video',
    videoTitle: 'Video Title',
    
    // Students
    students: 'Students',
    manageAccess: 'Manage Access',
    grantAccess: 'Grant Access',
    revokeAccess: 'Revoke Access',
    
    // Admin
    adminPanel: 'Admin Panel',
    dashboard: 'Dashboard'
  }
};

export function LangProvider({ children }) {
  const [lang, setLang] = useState('pt');

  const t = (key) => translations[lang][key] || key;

  const toggleLang = () => {
    setLang(prev => prev === 'pt' ? 'en' : 'pt');
  };

  return (
    <LangContext.Provider value={{ lang, setLang, t, toggleLang }}>
      {children}
    </LangContext.Provider>
  );
}

export function useLang() {
  return useContext(LangContext);
}
